var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAnimalsCow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.13019 13.3402L4.31827 24.3911L2.95961 25.6027C2.44384 26.0613 2.16865 26.9683 2.3348 27.6346L4.40654 35.9631H6.44192L5.59384 29.0331L8.75077 28.7561C9.46038 28.6921 10.395 28.2438 10.8779 27.7506L12.716 25.8727H27.964L34.2329 35.1877H36.6733L32.3013 26.4438L36.7858 27.6467V28.8375C36.7858 29.5281 37.151 30.5129 37.6044 31.0425L40.4308 34.3413C40.8825 34.8692 41.7998 35.2985 42.4921 35.2985H42.3813C43.0667 35.2985 43.541 34.7498 43.4371 34.0506L42.6271 28.5952L45 26.3158H42.0058L42.0802 26.7865C41.9976 26.5944 41.904 26.4071 41.7998 26.2258L33.9906 12.859C33.0387 11.2286 30.7281 9.9496 28.8554 10.0015L0.396343 10.7942H0V24.765H1.13019V13.3402ZM11.3019 27.979L11.0163 28.2871C10.549 28.7908 9.60057 29.2408 8.93596 29.2909L7.91134 29.3654L11.5287 35.6308L13.6748 35.6861L11.3019 27.979ZM27.5192 26.4265H26.3319L26.7767 35.4092H28.6494L29.1583 28.7561L27.5192 26.4265Z",
    fill: "#CB5E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3429 26.2319L16.2909 27.5192M14.1163 26.808L14.4195 28.3262M12.7722 26.8823L12.8155 28.5127",
    stroke: "#CB5E03",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0364 27.5648C10.6209 27.8614 8.51407 26.8912 8.33071 25.3979C8.14735 23.9045 9.95688 22.4535 12.3724 22.1569C14.7879 21.8603 16.8947 22.8305 17.0781 24.3238C17.2615 25.8172 15.4519 27.2682 13.0364 27.5648Z",
    fill: "#CB5E03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsCow);
export default __webpack_public_path__ + "static/media/ic-animals-cow.d01f850069a37c522599be244b9df547.svg";
export { ForwardRef as ReactComponent };